export enum CreatorSettingsViewsKeys {
  GLOBAL = 'global',
  SEAT = 'seat',
  LOVE_SEATS = 'loveSeats',
  ROW = 'row',
  SELECTION = 'selection',
  BASE_ELEMENT = 'baseElement',
  SECTOR = 'sector',
  GLOBAL_CONNECTIONS = 'globalConnections',
  CONNECTIONS = 'connections',
  SELECTION_CONNECTIONS = 'selectionConnections',
}
